<template>
  <div class="frimAuth">
    <nav-bar title="企业认证"></nav-bar>
    <div class="conent">
      <div class="title">
        <h6>加入企业或认证企业人员</h6>
        <p>注：请填写完整企业名称，员工号或手机号加入企业，进行企业身份认证</p>
      </div>
      <van-field v-model="value" placeholder="请输入企业名称" />
      <van-field v-model="value" placeholder="请输入员工号或手机号" />
      <van-button class="addBtn" type="default" color="rgba(33,37,41,1)" block
        >申请加入企业</van-button
      >
    </div>
    <div class="bgc"></div>
    <div class="file">
      <div class="title">
        <h6>企业认证上传营业执照复印件</h6>
        <p>
          注：使用平台服务管控企业用车情况，请上传 营业执照 或 组织机构代码
          的复印件，并且必须加盖红色企业公章;查看实例>
        </p>
      </div>
      <van-button class="addBtn" type="default" color="rgba(33,37,41,1)" block
        >上传证件（复印件）企业认证</van-button
      >
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import { Field, Button } from "vant";

export default {
  name: "frimAuth",
  components: {
    NavBar,
    "van-field": Field,
    "van-button": Button
  }
};
</script>

<style scoped lang="less">
.frimAuth {
  width: 100%;
  height: 100%;
  .conent {
    background-color: #fff;
    padding: 22px 25px 6px 25px;
    box-sizing: border-box;
    .title {
      margin-bottom: 16px;
    }
    h6 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
      margin: 0;
    }
    p {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(158, 160, 165, 1);
      margin: 0;
    }
    .van-field {
      border-bottom: 1px solid #ebedf0;
    }
    .addBtn {
      width: 325px;
      height: 44px;
      border-radius: 6px;
      margin: 35px auto;
    }
  }
  .bgc {
    height: 6px;
    background: rgba(239, 240, 241, 1);
  }
  .file {
    background-color: #fff;
    padding: 18px 25px 42px 25px;
    box-sizing: border-box;
    .title {
      margin-bottom: 16px;
    }
    h6 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
      margin: 0;
    }
    p {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(158, 160, 165, 1);
      margin: 0;
    }
    .addBtn {
      width: 319px;
      height: 49px;
      border-radius: 6px;
      opacity: 0.3;
    }
  }
}
</style>
